import InquiryView from "../components/home/InquiryView";
import { useEffect, useState } from "react";
import { HeadsetIcon } from "lucide-react";
import axios from "axios";
import FooterView from "../components/home/layout/FooterView";
import { useLocation } from "react-router-dom";

const Inquirypage: React.FC = () => {
  const [phoneInput, setPhoneInput] = useState("");
  const [formData, setFormData] = useState({
    content: "", //내용
    manager_email: "", // dohyun8032@gmail.com
    manager_name: "", // 김도현
    manager_phone: "", // 01040559598
    shop_name: "", // 매장 이름
    shop_tell: "", // 매장 전화번호
  });

  const [mktFormData, setMktFormData] = useState({
    company_name: "", // 매장이름
    ct_phone1: "",
    ct_phone2: "",
    ct_phone3: "",
    email: "", // 이메일
    person_name: "", // 성명
    spick: "", //내용
  });

  const handleFormChange = (field: string, value: string) => {
    setPhoneInput(value);
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleMktChange = (field: string, value: string) => {
    if (field === "manager_phone") {
      setPhoneInput(value);
    } else {
      setMktFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  const inquiryClick = async () => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i;
    const phoneDigits = phoneInput.replace(/\D/g, "") ?? "";
    try {
      if (selected === "receipt") {
        const {
          shop_name,
          manager_name,
          manager_email,
          manager_phone,
          shop_tell,
          content,
        } = formData;

        if (!shop_name.trim()) {
          return window.alert("회사명을 입력해주세요.");
        }

        if (!manager_name.trim()) {
          return window.alert("담당자명을 입력해주세요.");
        }

        if (!shop_tell.trim()) {
          return window.alert("매장 전화번호를 입력해주세요.");
        }

        if (!manager_phone.trim()) {
          return window.alert("전화번호를 입력해주세요.");
        }
        if (!emailRegex.test(manager_email)) {
          return window.alert("올바른 이메일을 입력해주세요.");
        }

        if (!/^\d{11}$/.test(phoneDigits)) {
          return window.alert("휴대폰 번호를 숫자 11자리로 입력해주세요.");
        }
        const response = await axios.post("/insertQuery", formData);
        if (response.status == 200) {
          return window.alert("문의가 접수되었습니다.");
        }
      } else {
        const onlyDigits = phoneInput.replace(/\D/g, "");
        const {
          company_name,
          ct_phone1,
          ct_phone2,
          ct_phone3,
          email,
          person_name,
          spick,
        } = mktFormData;

        if (!company_name.trim()) {
          return window.alert("회사명을 입력해주세요.");
        }

        if (!person_name.trim()) {
          return window.alert("담당자명을 입력해주세요.");
        }
        if (!emailRegex.test(email)) {
          return window.alert("올바른 이메일을 입력해주세요.");
        }

        if (!/^\d{11}$/.test(phoneDigits)) {
          return window.alert("휴대폰 번호를 숫자 11자리로 입력해주세요.");
        }

        if (!spick.trim()) {
          return window.alert("문의사항을 입력해주세요.");
        }

        const p1 = onlyDigits.slice(0, 3);
        const p2 = onlyDigits.slice(3, 7);
        const p3 = onlyDigits.slice(7, 11);

        const payload = {
          ...mktFormData,
          ct_phone1: p1 || "",
          ct_phone2: p2 || "",
          ct_phone3: p3 || "",
        };
        const response = await axios.post("/enquiryI", payload);

        if (response.status == 200) {
          return window.alert("문의가 접수되었습니다.");
        }
      }
    } catch (err) {
      window.alert(err);
      console.log(err);
    }
  };

  const marketInquryItems = [
    {
      title: "회사명",
      type: "text",
      id: "company_name",
      placeholder: "회사명을 입력하세요",
    },
    {
      title: "담당자명",
      type: "text",
      id: "person_name",
      placeholder: "담당자명을 입력하세요",
    },
    {
      title: "이메일",
      type: "email",
      id: "email",
      placeholder: "ex) example@gmail.com",
    },
    {
      title: "전화번호",
      type: "text",
      id: "manager_phone",
      placeholder: "연락처를 입력하세요",
    },
    {
      title: "문의 사항",
      type: "text",
      id: "spick",
      placeholder: "최대 300자 입력가능",
      height: "44",
      multiline: true,
    },
  ];

  const digitalInquryItems = [
    {
      title: "회사명",
      type: "text",
      id: "shop_name",
      placeholder: "회사명을 입력하세요",
    },
    {
      title: "담당자명",
      type: "text",
      id: "manager_name",
      placeholder: "담당자명을 입력하세요",
    },
    {
      title: "이메일",
      type: "email",
      id: "manager_email",
      placeholder: "ex) example@gmail.com",
    },
    {
      title: "전화번호",
      type: "text",
      id: "manager_phone",
      placeholder: "연락처를 입력하세요",
    },
    {
      title: "매장 전화번호",
      type: "text",
      id: "shop_tell",
      placeholder: "매장 전화번호를 입력하세요",
      height: "12",
    },
    {
      title: "문의 사항",
      type: "text",
      id: "content",
      placeholder: "최대 300자 입력가능",
      height: "44",
      multiline: true,
    },
  ];
  const inquiryType = useLocation();
  const [selected, setSelected] = useState<"receipt" | "marketing">("receipt");
  useEffect(() => {
    if (inquiryType.state && inquiryType.state.type) {
      const type = inquiryType.state.type;
      if (type === "marketing" || type === "receipt") {
        setSelected(type);
      }
    }
  }, [inquiryType]);

  const options = [
    { id: "receipt", label: "전자영수증" },
    { id: "marketing", label: "디지털마케팅" },
  ] as const;
  return (
    <>
      <section className="inquiry-main-section w-full py-16 px-4 pt-40">
        <div className="max-w-screen-laptop mx-auto flex flex-col gap-5">
          <h1 className="font-sans font-bold desktop:text-4xl laptop:text-5xl whitespace-pre-line text-gray-900">
            {`접수 문의를 위해\n 아래 정보를 입력해주세요`}
          </h1>

          <div className="flex items-center gap-4 bg-gray-100 rounded-2xl px-6 py-4">
            <HeadsetIcon className="w-6 h-6 text-blue-600" />
            <span className="font-sans font-semibold text-lg text-[#333d4b]">
              고객센터 02-540-3111
            </span>
          </div>
          <div className="flex flex-col gap-2">
            <p className="font-sans font-semibold text-lg text-gray-800">
              접수 유형
            </p>
            <div className="flex items-center gap-6 font-sans font-semibold">
              {options.map((opt) => {
                const isActive = selected === opt.id;
                return (
                  <button
                    key={opt.id}
                    className={`py-2 px-4 w-1/2 rounded-lg ${isActive ? "bg-black text-white" : "bg-white text-black border border-black"}`}
                    onClick={() => setSelected(opt.id)}
                  >
                    {opt.label}
                  </button>
                );
              })}
            </div>
          </div>
          {selected === "receipt" ? (
            <InquiryView
              items={digitalInquryItems}
              values={formData}
              onChange={handleFormChange}
              onPhoneChange={(val) => setPhoneInput(val)}
            />
          ) : (
            <InquiryView
              items={marketInquryItems}
              values={mktFormData}
              onChange={handleMktChange}
              phoneValue={phoneInput}
              onPhoneChange={(val) => setPhoneInput(val)}
            />
          )}

          <div className="receipt-privacy-container mt-5">
            <div className="receipt-privacy-checkbox-container flex items-center">
              <input
                id="privacy-checkbox"
                value=""
                type="checkbox"
                className="receipt-privacy-checkbox type=checkbox w-4 h-4 text-blue-600 bg-gray-100 border border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2"
              />
              <label
                htmlFor="privacy-checkbox"
                className="receipt-privacy-checkbox-title text-xs font-sans font-normal text-gray-700 ml-2"
              />
              위 개인정보의 수집 및 이용에 대해 동의합니다.
            </div>
          </div>

          <button
            type="button"
            onClick={inquiryClick}
            className="text-black bg-white font-sans border-black border font-semibold rounded-lg text-sm px-5 py-2.5 me-2 mb-2 hover:bg-black hover:text-white"
          >
            문의하기
          </button>
        </div>
      </section>
      <FooterView />
    </>
  );
};

export default Inquirypage;
